var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-application-queue"},[_c('loan-work-queue-card',{attrs:{"layout":_vm.layoutData,"loanPhase":_vm.assist.dataType.LoanPhaseEnum.PAYMENT_PROCESSING.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }